export const cleanDiacritics = (str: string) => {
  if (!str) return '';
  str = str.trim().toLowerCase();

  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  str = str.replace(/[đĐ]/g, 'd');
  str = str.replace(/([^0-9a-z-_.\s])/g, '');
  str = str.replace(/-+/g, '-');

  return str.replace(/^(-+|-+)$/g, '');
};

export function handleSearchVietnamese(searchText, list, t) {
  if (!searchText) return list;

  searchText = searchText.trim().toLowerCase();
  const searchRegex = new RegExp(
    `(${searchText}|${cleanDiacritics(searchText)}${
      t ? `|${t(searchText)}` : ''
    }).*`,
    'ig'
  );

  return list.match(searchRegex);
}

export function customSearch(
  input: string,
  labelList: Record<string, any>,
  searchVietnamese: boolean,
  t: (arg0: string) => string
) {
  if (searchVietnamese) {
    return Object.keys(labelList).some((key) => {
      return Boolean(handleSearchVietnamese(input, labelList[key], t));
    });
  }

  return Object.keys(labelList).some((key) => {
    return labelList[key].toLowerCase().indexOf(input.toLowerCase()) !== -1;
  });
}

export const uuidv4 = () => {
  if (window.crypto?.randomUUID) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
};

export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export const isViewerMode = () => {
  const pathCheck = window.location.pathname.split('/');
  return pathCheck[pathCheck.length - 1] === 'viewer';
};

export const isDesktopMode = () => {
  const pathCheck = window.location.pathname.split('/');
  return pathCheck[pathCheck.length - 1] === 'desktop';
};

export const isConsultationMode = () => {
  const pathCheck = window.location.pathname.split('/');
  return pathCheck[pathCheck.length - 1] === 'consultation';
};

export const isPathologyMode = () => {
  const pathCheck = window.location.pathname.split('/');
  return pathCheck[pathCheck.length - 1] === 'microscopy';
};

export const validateEmptyString = (str: string): string | null => {
  return str?.length ? str : null;
};

export const createRange = (start: number, end: number): number[] => {
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

export const isPublicPortal = () => {
  const publicWorkspaceUrl = window.config?.publicWorkspaceUrl;
  const url = new URL(publicWorkspaceUrl);

  return url.origin === window.location.origin;
};

export const isInternalPortal = () => {
  const publicWorkspaceUrl = window.config?.publicWorkspaceUrl;
  const url = new URL(publicWorkspaceUrl);

  return url.origin !== window.location.origin;
};

export function findOnlyOneDraggedItem(before: any[], after: any[]) {
  const n = before.length;

  for (let i = 0; i < n; i++) {
    const item = before[i];
    const to = after.indexOf(item);

    if (i !== to) {
      // Giả lập mảng sau khi "kéo" item này từ i -> to
      const simulated = [...before];
      const [moved] = simulated.splice(i, 1);
      simulated.splice(to, 0, moved);

      const isSame = simulated.every((val, idx) => val === after[idx]);
      if (isSame) {
        return { item, from: i, to };
      }
    }
  }

  return null; // Không xác định được duy nhất 1 item bị kéo
}
